import { createPersist } from 'api/helper'
import { callCloudFunction } from 'utils/cloudbase'
import { LinkModel } from './types'

/**
 * 获取系统中所有友情链接
 * @description 用户本地缓存24小时
 */
export const getLinks = createPersist(async (): Promise<LinkModel[]> => {
    const resp = await callCloudFunction({
        action: 'getLinks'
    }) as LinkModel[]

    return resp || []
}, 'links', 24 * 60 * 60)